import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { PlaylistMessageInterface, MessageHelper, PendingCommand, } from "../../helpers";

interface Props {
  index: number,
  playlistMessage: PlaylistMessageInterface,
  sendCommand: (cmd: PendingCommand) => void
}

export const PlaylistMessage: React.FC<Props> = props => {


  const getPlaylistDetails = (pm: PlaylistMessageInterface) => {
    const start = pm.childPlaylistStart;
    const end = pm.childPlaylistEnd;

    let range = "Entire playlist";
    if (start > 1 || end < 999) {
      range = "Slides: " + start + " - " + end;
      /*
      range = "Start: ";
      if (start === 0) range += " At the beginning.";
      else if (start > 0) range += start + " slide(s) from the beginning.";
      else if (start < 0) range += Math.abs(start) + " slide(s) from the end.";
      range += "<br/>Play through: ";
      if (end >= 999) range += " The end.";
      else if (end === 0) range += " The beginning slide.";
      else if (end > 0) range += end + " slide(s) from the beginning.";
      else if (end < 0) range += Math.abs(end) + " slide(s) from the end.";
      */
    }

    return (<>
      <b>{pm.childPlaylist?.name}</b>
      <span dangerouslySetInnerHTML={{ __html: range }}></span>
    </>)

  }


  const getMessageDetails = (pm: PlaylistMessageInterface) => {
    return (<>
      <img src={MessageHelper.getThumbnailPath(pm.message)} alt="thumbnail" />
      <b>{pm.message?.name}</b>
      <span>{pm.message?.seconds} seconds, {pm.message.category}</span>
    </>);
  }

  const removeItem = (e: React.MouseEvent) => {
    e.preventDefault();
    props.sendCommand({ action: "remove", parameter: props.index.toString() });
  }

  const selectSubset = (e: React.MouseEvent) => {
    e.preventDefault();
    props.sendCommand({ action: "subset", parameter: JSON.stringify(props.playlistMessage) });
  }

  const selectConditions = (e: React.MouseEvent) => {
    e.preventDefault();
    props.sendCommand({ action: "conditions", parameter: JSON.stringify(props.playlistMessage) });
  }

  const params: any = new URLSearchParams(window.location.search);
  const mode = params.get("mode");
  const conditionsLink = (mode === "playlist" || mode === "library") ? <><a href="about:blank" onClick={selectConditions}><i className="fas fa-cog"></i></a> | </> : null;
  const subsetLink = (props.playlistMessage.childPlaylistId) ? <><a href="about:blank" onClick={selectSubset}><i className="fas fa-cog"></i></a> | </> : null;
  const details = (props.playlistMessage.childPlaylistId) ? getPlaylistDetails(props.playlistMessage) : getMessageDetails(props.playlistMessage);

  const getConditions = () => {
    let result = <></>;
    if (props.playlistMessage.conditions?.length > 0)
    {
      const display:string[] = [];
      props.playlistMessage.conditions.forEach((c) => {
        display.push(c.questionKeyName + c.operator + c.value + " (" + c.dataType + ")");
      });
      result = (<div style={{fontStyle:"italic", color:"#999", fontSize:11 }}>{display.join(", ")}</div>);
    }
    return result;
  }

  const getItemStyle = (isDragging: boolean, draggableStyle: any) => {
    return {
      opacity: isDragging ? 0.5 : 1,
      ...draggableStyle
    }
  }

  return (
    <>
      <Draggable key={props.index} draggableId={props.index.toString()} index={props.index}>
        {(provided, snapshot) => (
          <div className="list-group-item list-group-item-action" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)} >
            <div style={{ float: "right" }}>
              {conditionsLink}
              {subsetLink}
              <a href="about:blank" onClick={removeItem}><i className="fas fa-trash"></i></a>
            </div>
            {details}
            {getConditions()}

          </div>
        )}
      </Draggable>
    </>
  );
};